import { apiClient } from './client';

export interface AuditEntry {
  projectId: string;
  timestamp: string;
  flagId: string;
  flagKey: string;
  changedBy: string;
  changeType: 'create' | 'update' | 'delete' | 'env_toggle';
  diff: Record<string, { before: unknown; after: unknown }>;
}

export const auditApi = {
  list: (projectId: string) =>
    apiClient.get<AuditEntry[]>(`/projects/${projectId}/audit`).then(r => r.data),
};
